import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PodTrackerService {
  headers2:any[];
  searchVal = 1;
  headers: any[];
  finalresult: any[];
  dtOptions: {};
  responseList: any[];
  responseListExcel = [];
  public finalDataObject = { table: {}, excel: [] };
  dtOptionsenable = false;
  timestampval = "";
  LOGINURL: string = '/request';
  readonly pivottablefiltersinput = '/request';
  headerData_PendPODCustom: any;
  readonly item_es_apiBaseURL = environment.baseURL_FREQ;
  constructor(private http: HttpClient) { }

  get_otif_date_limit() {
    return this.http.get(this.item_es_apiBaseURL + "item_tracking/get_otif_date_limit");

  }
  getData(url){
    return this.http.get(url);
  }

  postData(url,body){
    return this.http.post(url,body);

  }

  post(finalpostObj) {
    this.headers = [];
    this.finalresult = [];
    this.dtOptions = {};
    this.responseList = [];
    this.responseListExcel = [];
    this.dtOptionsenable = false;
    this.headers = finalpostObj['tableData']['headers']
    this.finalresult = finalpostObj['tableData']['result'];
    this.finalDataObject = this.sortedResponseList(this.finalresult);
    if (this.finalDataObject)
      return this.finalDataObject
  }

  postMoglixSummary(finalpostObj) {
    this.headers = [];
    this.finalresult = [];
    this.dtOptions = {};
    this.responseList = [];
    this.responseListExcel = [];
    this.dtOptionsenable = false;
    this.headers = finalpostObj['data']['headers'];
    this.finalresult = finalpostObj['data']['result'];
    this.finalDataObject = this.sortedResponseListMS(this.finalresult);
    if (this.finalDataObject)
      return this.finalDataObject
  }

  
  sortedResponseList(finalresult) {
    for (var i in finalresult) {
      var obj = finalresult[i];
      let orderObject = {};
      let orderobjectwithoutcomma = {}
      for (var j in this.headers) {
        for (const key of Object.keys(obj)) {
          if (this.headers[j] == key) {
            orderObject[key] = obj[key];
            
            let regExp = /^\d*(\.)?(\d{0,10})?$/ 
            if(regExp.test(obj[key]))
                orderobjectwithoutcomma[key] = obj[key];
              else
                orderobjectwithoutcomma[key] = obj[key];
          }
        }
      }
      this.responseList.push(orderobjectwithoutcomma);
      this.responseListExcel.push(orderobjectwithoutcomma);

    }
    if (this.responseList) {
      this.dtOptions = this.tabledataDaywise(this.responseList);
    }

    if (this.responseList && this.responseListExcel)
      this.finalDataObject = { table: this.dtOptions, excel: this.responseListExcel };
    return this.finalDataObject;
  }

  sortedResponseListMS(finalresult) {
    for (var i in finalresult) {
      var obj = finalresult[i];
      let orderObject = {};
      let orderobjectwithoutcomma = {}
      for (var j in this.headers) {
        for (const key of Object.keys(obj)) {
          if (this.headers[j] == key) {
            orderObject[key] = obj[key];
            orderobjectwithoutcomma[key] = obj[key];
          }
        }
      }
      this.responseList.push(orderObject);
      this.responseListExcel.push(orderobjectwithoutcomma);

    }
    if (this.responseList) {
      this.dtOptions = this.tabledataMoglixSummary(this.responseList);
    }

    if (this.responseList && this.responseListExcel)
      this.finalDataObject = { table: this.dtOptions, excel: this.responseListExcel };
    return this.finalDataObject;
  }

  // , "createdCell": function (th, cellData, rowData, row, col) {
            
  //   if ( col == 0 ) {
  //     $(th).css({'position':'fixed'})
  //   }
  // }


  tabledataDaywise(tableData) {
    let headerData = [];
    //alert(this.headers);
    for (let item of this.headers) {
      headerData.push({ title: item, data: item , "createdCell": function (td, cellData, rowData, row, col) {
        if(col == 0){
         $(td).css({'background-color': 'lightgray','z-index': 500})
       }

       if(col == 1){
         $(td).css({'background-color': 'lightgray','z-index': 500})
       }

       if(col == 2){
         $(td).css({'background-color': 'lightgray','z-index': 500})
       }
      }
    });
    }
    this.dtOptions = {
      ordering:false,
      responsive: true,
      autoWidth: false,
      scrollX: true,
      scrollCollapse: true,
//         fixedColumns:{
//        leftColumns:1
//      },

     
      scrollY: '75vh',
      //pageLength: 10,
      paging: false,
      data: tableData,
      columns: headerData,  
      dom: '<"top"i><"bottom"flp>rt<"clear">',
       
      columnDefs: [
        {
          width: "300",
          targets: '_all',
          render: function (data, type, row, meta) {
     
           
             
            return '<span id="cellvalue">' + data + '</span>';
          }

        }
      ],

     

      language: {
        info: this.timestampval,

        "lengthMenu": "",
        //"zeroRecords": "",

        "infoEmpty": "",
        "infoFiltered": ""
      }
    };
    if (this.dtOptions) {
      this.dtOptionsenable = true;
    }
    return this.dtOptions;
  }



  tabledata(tableData) {
    let headerData = [];
    for (let item of this.headers) {
      headerData.push({ title: item, data: item, "createdCell": function (td, cellData, rowData, row, col) {
   
           
        // if ( item.includes('4') ) {
        //   $(td).css({'background-color':'#FFF2CC'})
        // }
         if(col == 0){
          $(td).css({'background-color': 'lightgray','z-index': 500})
        }

        if (rowData['KPIs'].includes("Commission Income (Net)") ||
        rowData['KPIs'].includes('OMS Net Shipping revenue') ||
        rowData['KPIs'].includes('Net OMS Tax') ||
        rowData['KPIs'].includes('Net Purchases (COGS)') ||
        rowData['KPIs'].includes('Discount to customers- Net')) {
          $(td).css({'color': 'red','font-size':'14px!important'})
         }

         if (rowData['KPIs'].includes('Revenue- OMS Retail') ||
         rowData['KPIs'].includes('Revenue- OMS Tax') ||
         rowData['KPIs'].includes('Revenue- Ebay') ||
         rowData['KPIs'].includes('Total Logistics cost') ||
         rowData['KPIs'].includes('Total PG Charges')) {
           $(td).css({'background-color':'black','color': 'white','font-size':'14px!important'})
          }
          if (rowData['KPIs'].includes("Gross Margin") || rowData['KPIs'].includes("CM1") || rowData['KPIs'].includes("CM2") ){
            $(td).css({'background-color':'#2e75b5','color': 'white','font-size':'14px!important'})
          }
         

        //  'Gross Margin' ||
        //  'Revenue- OMS Retail' ||
        //  'Revenue- OMS Tax' ||
        //  'Revenue- Ebay  ' ||
        //  'Total PG Charges' ||
        //  'Total Logistics cost' ||
      }
        
      });
    }

    this.dtOptions = {
      responsive: true,
      autoWidth: false,
      scrollX: true,
      scrollCollapse: true,
      ordering:false,
      fixedColumns: {
        leftColumns:3
      },
      scrollY: '70vh',
      paging: false,
      data: tableData,
      columns: headerData,
      dom: '<"top"i><"bottom"flp>rt<"clear">',
      columnDefs: [
        {
          width: "300",
          targets: '_all',
          
          render: function (data, type, row, meta,full) {
                return data;
            
          }
         
        }

        //{  className: "stickyColumn", targets: 0 }
      ],

      // fixedColumns:   true,
      language: {
        info: this.timestampval,
          search: '<i style="color:blue;font-size:12px;"></i>Search',
          searchPlaceholder: 'Search',
      
        "lengthMenu": "",
        //"zeroRecords": "",

        "infoEmpty": "",
        "infoFiltered": ""
      }

    };
    if (this.dtOptions) {
      this.dtOptionsenable = true;
    }
    return this.dtOptions;
  }



  tabledataMoglixSummary(tableData) {
    let headertopLevel_custom = [];

    console.log(this.headers);

    for (let hc = 0; hc < this.headers.length; hc++) {
      if (hc > 3)
      {
        if(this.headers[hc].includes("GMV"))
        headertopLevel_custom.push(this.headers[hc].slice(11));

        else
        headertopLevel_custom.push(this.headers[hc].slice(10));
      }
        else
        headertopLevel_custom.push(this.headers[hc]);
    }
    console.log(headertopLevel_custom)
    let headerData2 = [];
    let h = 0;
    for (let itemToplevel of this.headers) {
      headerData2.push({ title: headertopLevel_custom[h], data: itemToplevel, "createdCell": function (td, cellData, rowData, row, col) {
        console.log(rowData);
        if ( itemToplevel.includes('Q') ) {
          $(td).css({'background-color':'#FFF2CC','font-weight':600})
        }
         if(col == 0){
          $(td).css({'background-color': 'lightgray','z-index': 500})
        }

        if(col == 1){
          $(td).css({'background-color': 'lightgray','z-index': 500})
        }

        if(col == 2){
          $(td).css({'background-color': 'lightgray','z-index': 500})
        }

        if(col == 3){
          $(td).css({'background-color': 'lightgray','z-index': 500})
        }



         if (rowData['Business'].includes('Total')) {
          $(td).css({'background-color': '#28abb1','font-size':'14px!important'})
         }
         
         if (!(rowData['Business'].includes('Total')) && rowData['BU'].includes('Total')) {
          $(td).css({'background-color': '#3bd6da'})
         }

         if (!(rowData['Business'].includes('Total')) && !(rowData['BU'].includes('Total')) && (rowData['Zone'].includes('Total'))) {
          $(td).css({'background-color': '#94fcff','font-family':"Garamond!important"})
         }
      //  console.log(rowData)
      }
        
      });
      h++;
    }

    console.log(headerData2)




    
    this.dtOptions = {
      destroy: true,
      responsive: true,
      autoWidth: false,
      scrollX: true,
      scrollCollapse: true,      
      ordering:false,
      fixedHeader: true,
      fixedColumns: {
        leftColumns: 4
            
      },
      scrollY: '60vh',
      paging: false,
      data: tableData,
      columns: headerData2,
      dom: '<"top"i><"bottom"flp>rt<"clear">',
      columnDefs: [
        {
          width: "300",
          targets: '_all',
          render: function (data, type, row, meta,full) {
                
                return data;
          }
        }
      ],
      language: {
        info: this.timestampval,
        search: '<i style="font-size:12px;">Achieved/Target is <b style="color:red">0-85%</b>, <b style="color:#e59a0f">86%-95%</b>, <b style="color:green">>95%</b></i>',
        searchPlaceholder: 'Search',
      
        "lengthMenu": "",
        "infoEmpty": "",
        "infoFiltered": ""
      }

    };
    if (this.dtOptions) {
      this.dtOptionsenable = true;
    }
    return this.dtOptions;
  }
}
